import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class AdministratorService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public saveAdminLoginAlert(body: any): Observable<any> {
    return this.httpHelperService.post(`/admin/alert/save`, body);
  }
  public saveAdminEmergencyAlert(body: any, userId: string): Observable<any> {
    return this.httpHelperService.post(
      `/admin/alert/save?userId=${userId}`,
      body,
    );
  }

  public getAlertHistoryList(alertType): Observable<any> {
    return this.httpHelperService.get(
      `/admin/alert/list?alertType=${alertType}`,
    );
  }
  public getEAlertHistoryList(alertType): Observable<any> {
    return this.getAlertHistoryList(alertType);
  }

  public setLoginAlertArchived(body): Observable<any> {
    return this.httpHelperService.post(`/admin/alert/archive`, body);
  }
  public setEmergencyAlertArchived(body): Observable<any> {
    return this.setLoginAlertArchived(body);
  }
}
